module.exports = __webpack_public_path__ + "static/media/CodeQuest-1.a6cf8a7b.jpeg";